<template>
	<div>
		<v-chart :style="chart_style()" :options="line" @datazoom='onDataZoom($event,line)'/>
		<b-alert show variant="light">
			<ul v-if="modal==0">
				<li>按照天来量化情绪趋势,辅助判断情绪热度按天的顶底</li>
				<!-- <li>采用的是昨日涨停的股票汇总</li> -->
				<li>几根回调阴线后的第一根阳线往往是底部反转</li>
				<li>几根大阳后的第一根十字星往往是顶部反转</li>
			</ul>
			<ul v-if="modal==20">
				<!-- <li>按照天来量化情绪趋势,辅助判断情绪热度按天的顶底</li> -->
				<!-- <li>采用的是昨日人气top100的股票池</li> -->
				<!-- <li>几根回调阴线后的第一根阳线往往是底部反转</li> -->
				<!-- <li>几根大阳后的第一根十字星往往是顶部反转</li> -->
			</ul>
		</b-alert>
	</div>
</template>

<script>
	import ECharts from 'vue-echarts'
	import {
		request_zzquant
	} from "network/request.js"
	import Moment from 'moment'

    
	
	const dataZoomData = {
		"start": 50,
		"end": 100
	}

	export default {
		props: {
			title: String,
			subText: String,
			modal:String,
			chart_heigh:{type:String,default:'400px'}
		},
		computed:{
			get_modal(){
				return new Number(this.modal)
			}
		},
		components: {
			'v-chart': ECharts
		},
data() {
	return {
		colorblind: false,
		line: {
					title: {
						text: this.title,
						subtext: this.subText,
						left: '1%',
						// textAlign:'right',
					},
					tooltip: {
						trigger: 'axis',
						formatter: function(params) {
							// console.log(params)
							var h = "日期："+params[0].name + " <br />";
							params.forEach((item) => {
								var v = 0;
								if (item.seriesName == 'K') {
									v = item.seriesName +":";
									var changePercent = ((item.value[2] - item.value[5]) / item.value[5] * 100).toFixed(2);
									v += '<span>涨跌幅: ' + changePercent + '%</span>';
									v += '<br/><span>[open:'+item.value[1]+' close:'+item.value[2]+' high:'+item.value[3]+' low:'+item.value[4]+']</span>';
                                }
								else if (item.seriesName == 'MA5') {
									v = item.seriesName + ":"+ item.value+ " <br />";
								} 
								else   {
                                    v = item.value
                                }
                                h += v
							});
							return h;
						}
					},
					toolbox: { //下载
						show: true,
						feature: {
							saveAsImage: {}
						}
					},
					legend: {
						top: 10,
						left: 'center',
						data: ['K', 'MA5']
					},
					visualMap: {
						show: false,
						seriesIndex: 2,
						dimension: 2,
						pieces: [{
							value: 1,
							color: '#0072B2'
						}, {
							value: -1,
							color: '#E69F00'
						}]
					},
					xAxis: [{
							type: 'category',
							scale: true,
							boundaryGap: false,
							axisLine: {
								onZero: false
							},
							splitLine: {
								show: false
							},
							splitNumber: 20,
							min: 'dataMin',
							max: 'dataMax',
							axisPointer: {
								z: 100
							},
							axisLabel: {
								fontSize: 10
							},
						}
					],
					yAxis: [{
							scale: true,
							offset: 2,
							splitLine: {
								show: false
							},
							splitArea: {
								show: true
							},
							axisLine: {
								lineStyle: {
									color: '#C0C0C0',
									width: 1
								}
							},
							position: 'right',
							min: 'dataMin',
							max: 'dataMax',
						},
						
					],
					dataZoom: [
						// {
						// 	type: 'inside',
						// 	start: dataZoomData.start,
						// 	end: dataZoomData.end
						// },
						{
							show: true,
							type: 'slider',
							xAxisIndex: [0],
							y: '90%',
							start: dataZoomData.start,
							end: dataZoomData.end
						}
					],
					series: []
				}
			}
		},
mounted() {
	this.refresh();
    { const c = localStorage.getItem('site.colorblind'); if(c){ this.colorblind = (c==='1' || c==='true') } }
    window.addEventListener('site-colorblind-changed', this.onColorblindChanged)
},
    beforeDestroy(){ window.removeEventListener('site-colorblind-changed', this.onColorblindChanged) },
    created(){ this.onColorblindChanged = (e)=>{ const v = e && e.detail && typeof e.detail.colorblind!=='undefined' ? !!e.detail.colorblind : (localStorage.getItem('site.colorblind')==='1' || localStorage.getItem('site.colorblind')==='true'); this.colorblind = v; this.refresh() } },
		methods: {
			chart_style(){
				return {
					width: '100%',
					height: this.chart_heigh,
				}
			},
			calculateMA(dayCount, data) {
				var result = [];
				for (var i = 0, len = data.values.length; i < len; i++) {
					if (i < dayCount) {
						result.push('-');
						continue;
					}
					var sum = 0;
					for (var j = 0; j < dayCount; j++) {
						sum += data.values[i - j][1];
					}
					result.push(+(sum / dayCount).toFixed(2));
				}
				return result;
			},onDataZoom(event,option){
				if(event.type == 'datazoom'){
					let last_end = event.end
					if(event.start == 0){
						let data_start = Moment(option.xAxis[0].data[0])
						if(data_start <= Moment('2020-02-27')){
							return
						}
						let data_start_new = data_start.add(-6,'months').format("YYYY-MM-DD")
						// console.log(data_start_new)
						this.line.dataZoom[0].start=10
						this.line.dataZoom[0].end=last_end
						this.refresh(data_start_new)
					}
					
				}
			},
			refresh(data_start) {
				this.line['title']  = {
					text: this.title,
					subtext: this.subText,
				};
				// 2020-02-27
				let url = '/v2/api/sentiment/kline/day/'+this.modal+'?date1='
				if(data_start){
					url += data_start
				}else{
					url += Moment().add(-12,'months').format('YYYY-MM-DD'); 
				}
				request_zzquant({
					'url': url
				}).then((resp1) => {
						// console.log(resp1);
						let splitDataItem = this.splitData(resp1['data']['data']);
						this.line['xAxis'] = [{
							data: splitDataItem.categoryData,
						}]
					let series_data = []
					const upColor = this.colorblind ? '#E69F00' : '#ec0000'
					const downColor = this.colorblind ? '#0072B2' : '#00da3c'
						// 添加MA3
						series_data.push({
							name: 'MA3',
							data: this.calculateMA(3, splitDataItem),
							type: 'line',
							showSymbol: false,
							lineStyle: {
								normal: {
									width: 1,
									opacity: 0.5,
									color: '#FF9900' // 设置不同的颜色以区分MA5
								}
							},
							symbol: 'circle'
						});
						
						series_data.push({
							name: 'MA5',
							data: this.calculateMA(5, splitDataItem),
							type: 'line',
							showSymbol: false,
							lineStyle: {
								normal: {
									width: 1,
									opacity: 0.7
								}
							},
							symbol: 'circle',
							markLine:{
								symbol:'none',//去掉箭头
								lineStyle: {
									normal: {
										width: 1,
										opacity: 0.5,
										type:'dashed',
									}
								},
								label: {
									formatter: ""
								},
								data: splitDataItem.mark_line_day1
							}
						});

						series_data.push({
							name: 'K',
							// yAxisIndex:0,
							data: splitDataItem.values,
							type: 'candlestick',
						itemStyle: {
							normal: {
								color: upColor,
								color0: downColor,
								borderColor: upColor,
								borderColor0: downColor,
								borderWidth: 1.5
							}
						},
							markPoint: {
								symbol: 'diamond',
								symbolSize: 8,
								itemStyle: {
									color: '#4682B4',
									opacity: 0.7
								},
								label: {
									show: false
								},
								data: splitDataItem.iceData || []
							},
							markLine:{
								symbol:'none',//去掉箭头
								lineStyle: {
									type:'dotted',
									color: "#AAA",
									normal: {
										width: 1,
										color: "#AAA",
										opacity: 0.6,
									}
								},
								
								label: {
									formatter: ""
								},
								data: splitDataItem.mark_line_mon
							}

						});
						
						this.line['series'] = series_data
						if (this.line && this.line.visualMap && Array.isArray(this.line.visualMap.pieces)) {
							this.line.visualMap.pieces[0].color = downColor
							this.line.visualMap.pieces[1].color = upColor
						}
					})
					.catch(err => {
						console.log(err);
					})
			},
			splitData(rawData) {
				let[categoryData, values, p_close_pre1d, mark_line_mon,mark_line_day1,iceData,] = [
					[], [], [], [], [], [], ]
				let pre_month = -1
				rawData.forEach((item, index)  => {
					let item_date = item['date']
					categoryData.push(item_date)
					values.push([item['p_open'], item['p_close'], item['p_high'], item['p_low'], item['p_close_pre1d']])
					p_close_pre1d.push(item['p_close_pre1d'])

					if (index > 0) {
						const prevClose = item['p_close_pre1d'];
						const currClose = item['p_close'];
						const changePercent = ((currClose - prevClose) / prevClose * 100).toFixed(2);
						
						if (parseFloat(changePercent) <= -2) {
							iceData.push({
								name: 'Ice',
								value: changePercent,
								xAxis: index,
								yAxis: currClose
							});
						}
					}
					// 计算周一
					if(Moment(item_date).weekday()==1){
						mark_line_mon.push({
							xAxis:item_date,
							label: {formatter: item_date.substr(8)},
							})
					}
					if(Moment(item_date).month()!=pre_month){
						mark_line_day1.push({
							name:"月初", 
							label: {formatter: item_date.substr(5)},
							xAxis:item_date})
						pre_month = Moment(item_date).month()
					}
					
				})
				return {
					categoryData: categoryData,
					values: values,
					p_close_pre1d:p_close_pre1d,
					mark_line_mon:mark_line_mon,
					mark_line_day1:mark_line_day1,
					iceData:iceData
				};
			},
		}
	}
</script>

<style scoped>
.chart_stock_kline_popular {
	width: 100%;
	height: 600px;
}
</style>
